/**
 * Created by Ram on 4/10/2016.
 */

import React, { Component } from 'react';
import { navigate } from '@reach/router'

export default class CustomerNav extends Component {
    render() {
        const { account } = this.props

        return (
            <div className="customers-navbar">
                <div className="col-md-4 col-sm-12">
                    <label>{account.name}</label>
                </div>
                <div className="col-md-8 col-sm-12 customer-navbar_buttons">
                    <button onClick={() => navigate(`/customer/${account._id}`) }><span className="glyphicon glyphicon-user"></span> <p>CUSTOMER</p></button>
                    <button onClick={() => navigate(`/customer/${account._id}/tools`)}><span className="glyphicon glyphicon-stats"></span> <p>TOOLS</p></button>
                    <button onClick={() => navigate(`/customer/${account._id}/sso`)}><span className="glyphicon glyphicon-cloud"></span> <p>CANVAS</p></button>
                </div>
            </div>
        )
    }
}
